var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtualtouricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1015_164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4749 0.00476074L38.8403 9.06277H11.1598L2.5251 0.00476074L0 1.01541V49.9952H50V1.01541L47.4749 0.00476074ZM47.0703 44.994L40.9325 38.8562V11.1138L47.0703 4.67507V44.994ZM11.1391 40.9277H38.8609L44.9987 47.0655H5.00127L11.1391 40.9277ZM11.9972 11.9924H38.0028V37.998H11.9972V11.9924ZM9.06748 11.1138V38.8561L2.92969 44.994V4.67507L9.06748 11.1138Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0799 19.8139L31.5507 18.3052L29.4529 16.2601L25.6335 20.1779L26.7036 25.0851L29.5661 24.4608L29.1598 22.5976C31.0489 23.2247 32.1518 24.2063 32.1518 24.9953C32.1518 26.228 29.3657 28.0185 25 28.0185C20.6343 28.0185 17.8482 26.228 17.8482 24.9953C17.8482 24.2934 18.6962 23.4881 20.061 22.8936L18.8912 20.2076C16.3665 21.3072 14.9185 23.0522 14.9185 24.9952C14.9185 26.7671 16.0947 28.3555 18.2305 29.4678C20.0631 30.4223 22.4672 30.948 25 30.948C27.5328 30.948 29.937 30.4223 31.7695 29.4678C33.9053 28.3554 35.0814 26.7671 35.0814 24.9952C35.0814 22.7519 33.1558 20.8321 30.0799 19.8139Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1015_164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualtouricon);
export default __webpack_public_path__ + "static/media/virtualtouricon.14a5aae961b0e7a2d90472fa4888e204.svg";
export { ForwardRef as ReactComponent };